import React, { useEffect, useRef, useState } from "react";
import { Tooltip, Modal } from 'antd';
import { useSelector } from "react-redux";
import styles from "./scss/recordedList.module.scss";
import { URButton } from "../../../shared/widgets/button";
import { initiateCall } from "../../../base/callService/callService";
import PopoverModule from "../callsWidgets/PopoverModule/PopoverModule";
import { DeleteAllRecordings, DeleteRecordings, getRecordingLogs } from "../../../base/callService/callsApiService";
import {
  timeStampConverter, toastInformation,
  searchHighlight, selectList, secondsToHMSConverter, listClkEvent, handlingKeyMovement
} from "../../../base/callService/common";
import { URCheckBoxCall } from "../../../shared/widgets/checkBoxForCall/callCheckBox";
import { URChatLeftSkeleton } from "../../../shared/widgets/skeletonLoading/chatLeftSkeleton";
import { storeChatWindow, storeParticularLog} from "../../../base/callService/store_mining";
import Lottie from "lottie-react";
import groovyWalkAnimation from "../../../styles/images/chat blank state loading.json";
import ContactLoader from "../../../styles/images/Lottie Animation.json";
import NoContent from "../../../shared/widgets/noContent";
import recordblank from "../../../styles/images/empty_states/empty-audio.svg";
import { initialStateModel } from "../../../models/model";
import store from "../../../context/store/store";

type recordingProps = {
  backEventTrigger: (data: any) => void;
};

type recordingState = {
  isClear: boolean;
  listOffset: number;
  tempList: any;
  doneList: any;
  isModalVisible: boolean;
};

export default function RecordedLists({backEventTrigger}:recordingProps) {
  const [recordingState, setRecordingState] = useState<recordingState>({
    isClear: false,
    listOffset: 0,
    tempList: [],
    doneList: [],
    isModalVisible: false
  });
  let { tempList, isClear, listOffset, isModalVisible } = recordingState;

  let { callReducer}: initialStateModel = useSelector((state: initialStateModel) => state);

  let { totalRecordings, particularLog ,logs, logsInput, isLogLoading} = callReducer;
  
  // let logs = searchHandler(list,socketInput.search);
    
  const recordingBackPress = () => {
    backEventTrigger('callList');
  };

  const isDelete = () => {
    (tempList.length > 0) ?
      (setRecordingState({ ...recordingState, isModalVisible: true })) :
      toastInformation("No Recording selected", "warning");
  };
  const selectAll = (e: any) => {
    if (e.target.checked) {
      let allList = logs?.map((data: any) => {
        return data.uuid;
      });
      setRecordingState({
        ...recordingState, doneList: allList, tempList: allList
      });
    }
    else { cancelSelection(); }
  };

  const cancelSelection = () => {
    setRecordingState({ ...recordingState,doneList: [], tempList: [] });
  };

  const confirmDelete = () => {
    tempList.length===logs.length?DeleteAllRecordings():DeleteRecordings(tempList);
    closeAll();
  };
  const closeAll = () => {
    setRecordingState({ ...recordingState,isClear: false,doneList: [],tempList: [],isModalVisible:false});
  };

  const closeModal = () => {
    setRecordingState({ ...recordingState,isModalVisible: false });
  };

  const selectRecordings = (uuid: any) => {
    setRecordingState({
      ...recordingState, tempList:selectList(tempList,uuid)
    });
    
  };
  const deleteEventTrigger = () => {
    setRecordingState({ ...recordingState, isClear: true });
  };
  const handleScroll = (e: any) => {
    const bottom = e.target.scrollHeight - Math.round(e.target.scrollTop) === e.target.clientHeight;
    if (bottom) {
      setRecordingState({
        ...recordingState, listOffset: listOffset + 10
      });
      // contactService.getCalRecList(socketInput.limit,listOffset+25);

      getRecordingLogs(listOffset + 10,logsInput.search);

    }
  };

  const detailPage = (list: object) => {
    let {isProfileView}=store.getState().updatedCallList||{};
    if(isProfileView===true){storeChatWindow(list)}
    storeParticularLog(list,false)
    listClkEvent();
    //max_Call_Window();
  };
  const selectSingle = (data: any) => {
    tempList.push(data.uuid);
    setRecordingState({
      ...recordingState, doneList: tempList,isModalVisible: true
    });
  };


  const activeContact = useRef(null);
  const keyHandler = (ev: any) => {
    let startFocus:any=activeContact.current;
      if ((ev.keyCode === 38 || ev.keyCode === 40)&&startFocus!==null) {
        let movingPosition:any = 0;
        if (particularLog) {  
           movingPosition = handlingKeyMovement(ev);
          startFocus.scrollIntoViewIfNeeded();
  
          if (!movingPosition && movingPosition === undefined) movingPosition = 0;
          let { logs} = store.getState().callReducer||{};
          detailPage(logs[movingPosition]);

  
        }
      }
    };


  useEffect(() => {
    window.addEventListener("keyup", (e: KeyboardEvent) => keyHandler(e));
    return () => {
      window.removeEventListener("keyup", keyHandler );
    };
  }, []);
  var len = Math.round((logs?.length / 8));
  var random_color = Array(len).fill([1,2,3,4,5,6,7,8]).flat();
  return (
    <>
      <div className={styles.voiceMaillistmain}>
        {/* <div className={styles.rightbartop}>
          <div className={styles.lefts} title="Back" onClick={recordingBackPress}>
            <span className={styles.backArrow}></span> Record Calls  
          </div>
          <div className={styles.rights}>
          {totalRecordings}
          </div>
        </div> */}
        <div className={styles.clearLogLeft}>
          <div className={styles.checkBoxArea}>
            {isClear && (!isLogLoading) &&
              <URCheckBoxCall checked={(tempList?.length) === (logs?.length) ? true : false}
                onChange={(e: any) => selectAll(e)} />}
          </div>
          {!isLogLoading&&<div className={styles.btnSec}>
            {tempList?.length>0 &&isClear&&
              <URButton className='urButton buttonTransparent fordeleting'
                name={(tempList?.length) === (logs?.length) ? 'Delete All' : 'Delete'}
                onClick={isDelete} />
            }
            {isClear&&<URButton className='urButton buttonTransparent' name='Cancel' onClick={closeAll} />}
            
            {(!isClear && logs?.length > 0) &&
              <URButton className='urButton buttonTransparent' name='Clear Log' onClick={deleteEventTrigger} />}
          </div>}
        </div>
        <div className={styles.rightbarbottom}>
          {/* <NoCalls /> */}
          <div className={`${styles.scrolllayerleft} ${"scrollerhover"}`} onScroll={handleScroll}>
            {(logs && logs?.length > 0) ?
              <>{logs?.map((list: any, index: any) => {
                let message: any = searchHighlight(list, logsInput.search );
                return <div key={index} onClick={ () => isClear ? selectRecordings(list?.uuid) : detailPage(list) }>
                  <div className={ particularLog?.uuid === list?.uuid ?
                    `${styles.profilelists} ${styles.active}` : `${styles.profilelists}`} ref={(particularLog?.uuid === list?.uuid)?activeContact:null}>
                    <div className={`${styles.clearSelect} ${styles.clearSelected}`}>
                      {isClear&& <URCheckBoxCall checked={tempList?.indexOf(list?.uuid) > -1 ? true : false}/>}
                    </div>
                    <div title="View contact details">
                      <PopoverModule popOverValues={list} randomColor={random_color[index]} value={false} />
                      </div>
                    <div className={styles.vmsideDetails}>
                      <div className={styles.frow}>
                        {(logsInput?.search !== ""&&message.key==='name') ?
                          (
                            <h4>{(message?.middleMsg !== "") ?(<>{message?.firstMsg}
                              <b className={styles.highlight}>{message?.middleMsg}</b>{message?.lastMsg}</>):
                              ( <>{list?.caller_id }</>)}</h4>):
                          (<h4>{list?.caller_id }</h4>)
                        }

                        <p><span className={list?.call_direction === 'Outbound' ? styles.outGoingCall :
                          (list?.call_direction === 'Inbound' ? styles.incomingCall : styles.missedCall)}></span>
                        <span className="icon_recordleftpanel"></span>
                          {secondsToHMSConverter(parseInt(list?.recording_duration))}</p>
                      </div>
                      <div className={styles.secondrow}>
                      {(logsInput?.search !== ""&&message.key==='date') ?
                          (
                            <span>{(message?.middleMsg !== "") ?(<>{message?.firstMsg}
                              <b className={styles.highlight}>{message?.middleMsg}</b>
                              {message?.lastMsg}</>):
                              (<>{timeStampConverter(list?.created_at,'list')}</>)}</span>
                          ) :
                          (<span>{timeStampConverter(list?.created_at,'list')}</span>)
                        }
                     
                      </div>
                    </div>
                  {!isClear&& <div className={styles.hoverdiv}>
                      <ul>
                        <li><Tooltip placement="top" title="Call"><span className={styles.iconCall}
                          onClick={() =>initiateCall(list?.ext, 'audio')}></span></Tooltip></li>
                        <li><Tooltip placement="top" title="Delete"><span className="icon_delete"
                          onClick={() =>selectSingle(list)}></span></Tooltip></li>
                      </ul>
                    </div>}
                  </div>
          
                </div>;
              })}
              {isLogLoading &&
                  <Lottie className="svgLoadinglist" animationData={ContactLoader} />
              }
             
              </>
              : <>
                {logs?.length===0&&!isLogLoading? 
                 <NoContent image={recordblank}
              title={'No Recorded calls yet'}
              description={''} />
              :
                  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]?.map((index: any) => (
                    <div key={index}><URChatLeftSkeleton />
                    </div>
                  ))
                  
                  
                  }
              </>}
          </div>
        </div>

      </div>
      <Modal title={tempList.length===logs.length?"Delete All Recorded Calls?":"Delete Selected Recorded Calls?"}
        centered
        visible={isModalVisible}
        onOk={confirmDelete}
        onCancel={closeModal}
        cancelText="Cancel"
        okText=  {tempList.length===logs.length?"Delete All":"Delete"}
        cancelButtonProps={{ className: 'urButton buttonWhite' }} 
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
        {tempList.length===logs.length?"Are you sure want to delete all the recorded calls?":"Are you sure want to delete the selected recorded calls?"}
        
      </Modal>
    </>
  );
};